import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { createStructuredSelector } from 'reselect';
import { downloadAIPhoto, generateAIPhoto, initAIDownloads } from './actions';
import AIFooter from './AIFooter';
import AIHeader from './AIHeader';
import AITopPhotos from './AITopPhotos';
import {
  makeSelectDownloadPhotoLoading,
  makeSelectPhoto,
  makeSelectPhotoLoading,
  makeSelectRemainingDownloads,
} from './selectors';
import reducer from './reducer';
import saga from './saga';
import ButtonDownloadAIPhoto from './ButtonDownloadAIPhoto';
import { makeSelectIsAuthenticated } from '~/containers/AuthProvider/selectors';
import Config from '~/config';
import ButtonPinterest from '~/components/ImagesPreview/ButtonPinterest';
import Breadcrumb from '~/components/Breadcrumb';
import injectSaga from '~/../hocs/injectSaga';
import injectReducer from '~/../hocs/injectReducer';
import withI18next from '~/../hocs/_withI18next';

const styles = {
  iconLoading: {
    width: 22,
    marginRight: 7,
  },
};

@injectReducer({ key: 'aiPhoto', reducer })
@injectSaga({ key: 'aiPhoto', saga })
@withI18next()
class AIPhotoContainer extends React.Component {
  componentDidMount() {
    const { initAIDownloads } = this.props;
    initAIDownloads();
  }

  handleClickPinterest = () => {
    const { photo } = this.props;
    /* eslint-disable */
    PinUtils.pinOne({
      url: window.location.href,
      media: photo.image_url,
    });
  };

  handleFreeDownloadClick = () => {
    const {
      openLoginModal,
      isAuthenticated,
      photo,
      downloadAIPhoto,
    } = this.props;
    if (!isAuthenticated) {
      // return openLoginModal();
      window.location.href = `${Config.ssoServerUrl}/login?lang=${
        this.props.lng
      }&serviceURL=${encodeURIComponent(
        process.browser ? window.location.href : '',
      )}`;
      return;
    }
    downloadAIPhoto(photo.image_url);
  };

  handleGenerateAIPhoto = () => {
    const { openLoginModal, isAuthenticated, generateAIPhoto } = this.props;
    if (!isAuthenticated) {
      // return openLoginModal();
      window.location.href = `${Config.ssoServerUrl}/login?lang=${
        this.props.lng
      }&serviceURL=${encodeURIComponent(
        process.browser ? window.location.href : '',
      )}`;
      return;
    }
    generateAIPhoto();
  };

  render() {
    const {
      photo,
      downloadPhotoLoading,
      isAuthenticated,
      generateAIPhoto,
      loading,
      t,
      remainingDownloads,
      lng,
    } = this.props;

    let timesText = null;
    if (remainingDownloads === 0) {
      timesText = t('times_0', { count: remainingDownloads });
    } else if (remainingDownloads === 1) {
      timesText = t('more_time', { count: remainingDownloads });
    } else {
      timesText = t('more_times', { count: remainingDownloads });
    }

    return (
      <div className="ai-photo-page">
        <div className="col-sm-12 bg-white">
          <Breadcrumb title={t('ai_photo')} />
        </div>
        <div className="main-container">
          <AIHeader />
          <div
            className="container-fluid bg-gray photo-container"
            // itemScope
            // itemType="http://schema.org/ImageObject"
          >
            <div className="photo-section-left">
              <figure className="photo-preview">
                <div className="overlay-button-pinterest">
                  <ButtonPinterest onClick={this.handleClickPinterest} />
                </div>
                <img className="main-photo" src={photo.image_url} />
                <p className="main-photo-description">
                  ※{t('generated_photo_description')}
                </p>
              </figure>
            </div>
            <div className="sticky-right photo-section-right">
              <h1 className={`text-ai-photo ${Config.serviceType}`}>
                {t('ai_photo')}
              </h1>
              <h2
                className="text-times"
                dangerouslySetInnerHTML={{ __html: timesText }}
              />
              <p>{t('limit_generations')}</p>
              <button
                className={`btn btn-ac-primary btn-${Config.serviceType} btn-create`}
                onClick={this.handleGenerateAIPhoto}
                disabled={remainingDownloads === 0 || loading}
              >
                {loading ? (
                  <FontAwesomeIcon
                    icon={faSpinner}
                    style={styles.iconLoading}
                    pulse
                  />
                ) : (
                  t('create')
                )}
              </button>
              <p className="hint">{t('generation_description')}</p>
              <div className="photo-actions">
                <div className="action-container">
                  <ButtonDownloadAIPhoto
                    onClick={this.handleFreeDownloadClick}
                    loading={downloadPhotoLoading}
                  />
                </div>
              </div>
              <ul className="ai-notes">
                <li>※{t('ai_notes_1')}</li>
                <li
                  dangerouslySetInnerHTML={{
                    __html: `※ ${t('ai_notes_2', {
                      termsURL: `${Config.getSiteURL()}/terms-ai`,
                      service_type: Config.serviceType,
                    })}`,
                  }}
                />
              </ul>
            </div>
          </div>
          <AITopPhotos />
          <AIFooter />
        </div>
        <ToastContainer />
        <style jsx global>
          {`
            .ai-photo-page {
              display: flex;
              flex-direction: column;
              align-items: center;
            }
            .ai-photo-page .main-container {
              width: 100%;
              max-width: 950px;
              margin: 0 28px;
            }
            .ai-photo-page .photo-container {
              display: flex;
              flex-direction: row;
              padding: 28px;
              margin-top: 28px;
            }
            .ai-photo-page .photo-container .photo-preview {
              position: relative;
              background: #fff;
              min-width: 600px;
              min-height: 400px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              border-radius: 2px;
              padding: 14px;
            }
            .ai-photo-page .photo-container .overlay-button-pinterest {
              position: absolute;
              top: 5px;
              left: 5px;
              color: #fff;
            }
            .ai-photo-page .photo-container .main-photo {
              width: 550px;
            }
            .ai-photo-page .photo-container .main-photo-description {
              margin-top: 14px;
              text-align: center;
            }
            .ai-photo-page .photo-container .photo-section-right {
              display: flex;
              flex-direction: column;
              align-items: center;
              background: #fff;
              padding: 14px;
              margin-left: 28px;
              width: 400px;
              text-align: center;
            }
            .ai-photo-page .photo-container .photo-section-right h1,
            .ai-photo-page .photo-container .photo-section-right h2,
            .ai-photo-page .photo-container .photo-section-right small,
            .ai-photo-page .photo-container .photo-section-right p {
              padding: 0;
              margin: 0;
              color: #1b2833;
            }
            .ai-photo-page
              .photo-container
              .photo-section-right
              .text-ai-photo {
              font-size: 40px;
              font-weight: bold;
            }
            .ai-photo-page
              .photo-container
              .photo-section-right
              .text-ai-photo.photo_ac {
              color: #509bdc;
            }
            .ai-photo-page .photo-container .photo-section-right .text-times {
              font-size: 70px;
              font-weight: 700;
            }
            .ai-photo-page
              .photo-container
              .photo-section-right
              .text-times
              small {
              font-size: 20px;
              font-weight: 500;
              margin-left: 7px;
            }
            .ai-photo-page .photo-container .photo-section-right .btn-create {
              min-width: 100px;
              height: 100px;
              font-size: 22px;
              margin-top: 14px;
              padding: 14px;
            }
            .ai-photo-page .photo-container .photo-section-right .hint {
              margin-top: 7px;
            }
            .ai-photo-page
              .photo-container
              .photo-section-right
              .photo-actions {
              display: flex;
              flex-direction: column;
              margin-top: 28px;
              background: #f2f3f4;
              width: 100%;
            }
            .ai-photo-page
              .photo-container
              .photo-section-right
              .photo-actions
              .action-container {
              margin: 7px;
            }
            .ai-photo-page .photo-container .photo-section-right .ai-notes {
              text-align: left;
              margin-top: 14px;
              list-style: none;
              padding: 0;
            }
            .ai-photo-page .photo-container .photo-section-right .ai-notes li {
              padding: 0;
            }
            @media (max-width: 767px) {
              .ai-photo-page .photo-container {
                flex-direction: column;
              }
              .ai-photo-page .photo-container .photo-section-left,
              .ai-photo-page .photo-container .photo-section-right {
                width: 100%;
              }
              .ai-photo-page .photo-container .photo-section-right {
                margin-left: 0;
                margin-top: 28px;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  photo: makeSelectPhoto(),
  loading: makeSelectPhotoLoading(),
  downloadPhotoLoading: makeSelectDownloadPhotoLoading(),
  isAuthenticated: makeSelectIsAuthenticated(),
  remainingDownloads: makeSelectRemainingDownloads(),
});
const mapDispatchToProps = (dispatch) => ({
  generateAIPhoto: () => dispatch(generateAIPhoto()),
  initAIDownloads: () => dispatch(initAIDownloads()),
  downloadAIPhoto: (imageUrl) => dispatch(downloadAIPhoto(imageUrl)),
  // openLoginModal: () => dispatch(openModal()),
});
export default connect(mapStateToProps, mapDispatchToProps)(AIPhotoContainer);
